module.exports = __webpack_public_path__ + "img/blockworld.85625e6c.png";